import React from "react"
import Typography from "../../../../../ui/atoms/Typography"
import { formatMoney } from "../../../../../utils/money"
import { useLabels } from "../../../../contents/hooks"
import { Basket } from "../../../state/checkoutTypes"

interface Props {
  basket: Basket
}

const ShippingRecapPrice = ({ basket }: Props) => {
  const { getLabel } = useLabels()
  if (basket.recap.shipping !== undefined) {
    return (
      <div className="text-right">
        {(basket.recap.shipping.compareAtPrice ?? 0) > 0 ? (
          <Typography variant="body1" lineTrough color="error">
            {formatMoney({
              amount: basket.recap.shipping.compareAtPrice,
              currency: basket.recap.shipping.currency,
              currencyPosition: "after",
            })}
          </Typography>
        ) : undefined}
        <Typography variant="body1">
          {basket.recap.shipping.price > 0
            ? formatMoney({
                amount: basket.recap.shipping.price,
                currency: basket.recap.shipping.currency,
                currencyPosition: "after",
              })
            : getLabel("basket", "price-shipping-free")}
        </Typography>
      </div>
    )
  }

  if (basket.shipping.hasFreeShippingPromo) {
    return (
      <Typography variant="body1">
        {getLabel("basket", "price-shipping-free")}
      </Typography>
    )
  }
  return (
    <Typography variant="body1">
      {getLabel("basket", "price-shipping-next-step")}
    </Typography>
  )
}

export default ShippingRecapPrice
